import React, { useEffect, useReducer, useState } from 'react';
import { useDispatch, useSelector, useStore } from 'react-redux';
import VideoPlayer from 'app/components/tv/VideoPlayer';
import { Helmet } from 'react-helmet-async';
import { addPlaylistVideo, fetchTvPlaylist } from 'app/routes/tv/TvPlaylistPageActions';
import TvPlaylistPageReducer from 'app/routes/tv/TvPlaylistPageReducer';
import { useParams, useHistory } from 'react-router';
import { useFetchData, useRestoreData } from 'app/hooks/dataHooks';
import { getMetaData } from 'app/components/tv/helpers/getMetaData';
import { useAdsConsent } from 'app/components/tv/helpers/useAdsConsent';
import { useWebSockets } from 'app/hooks/useWebSockets';
import { selectWebsocketData } from 'app/hooks/reduxCreateSelectorHooks';
import { VideoBlocked } from 'app/components/tv/VideoBlocked';
import Playlist from 'app/components/tv/models/Playlist';
import VideoCreator from 'app/components/tv/models/VideoCreator';
import is from '@sindresorhus/is';
import Video from 'app/components/tv/models/video';
export default function TvPlaylistPage() {
  var _playlist$allowWebsoc;
  const {
    videoSceneSlug,
    matchPlaylistSlug
  } = useParams();
  const {
    restoredData
  } = useRestoreData('TvPlaylistPage');
  const initialState = restoredData ? {
    ...restoredData,
    playlist: is.array(restoredData.playlist) ? Playlist.createByApi(restoredData.playlist) : restoredData.playlist,
    currentVideo: restoredData.currentVideo instanceof Video ? restoredData.currentVideo : VideoCreator.createVideo(restoredData.currentVideo)
  } : {
    isFetching: false,
    playlist: null,
    currentVideo: null,
    ssrLoaded: false
  };
  const [state, dispatch] = useReducer(TvPlaylistPageReducer, initialState);
  const dispatchRedux = useDispatch();
  const {
    getState
  } = useStore();
  const loadData = () => fetchTvPlaylist(matchPlaylistSlug, videoSceneSlug, dispatchRedux, getState)(dispatch, state);
  const {
    playlist,
    currentVideo,
    isFetching,
    ssrLoaded
  } = state;
  useFetchData(state, loadData, 'TvPlaylistPage');
  const history = useHistory();
  const {
    title,
    meta,
    schema
  } = getMetaData(playlist, videoSceneSlug, history.location.pathname);
  const adsConsent = useAdsConsent();
  const websocketData = useSelector(selectWebsocketData);
  const [subscribed, setSubscribed] = useState(false);
  const conditionalTrigger = (_playlist$allowWebsoc = playlist === null || playlist === void 0 ? void 0 : playlist.allowWebsocket()) !== null && _playlist$allowWebsoc !== void 0 ? _playlist$allowWebsoc : false;
  const {
    websocketOpen,
    subscribeToChannel
  } = useWebSockets(dispatchRedux, conditionalTrigger);
  useEffect(() => {
    if (websocketOpen && playlist !== null && playlist !== void 0 && playlist.hasVideos() && !subscribed) {
      subscribeToChannel("playlist.".concat(playlist.getPlaylistId()));
      setSubscribed(true);
    }
  }, [websocketOpen, playlist, subscribed]);
  useEffect(() => {
    if ((websocketData === null || websocketData === void 0 ? void 0 : websocketData.event) === 'video.created') {
      const newVideo = VideoCreator.createVideo(websocketData.data);
      dispatch(addPlaylistVideo(newVideo));
    }
  }, [websocketData]);

  // Redirect Playlist-URL without scene to first scene
  useEffect(() => {
    if (videoSceneSlug || !currentVideo) {
      return;
    }
    history.replace("/tv/match/".concat(matchPlaylistSlug, "/").concat(currentVideo.slug));
  }, [currentVideo, matchPlaylistSlug, videoSceneSlug]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Helmet, {
    title: title,
    meta: meta,
    "data-sentry-element": "Helmet",
    "data-sentry-source-file": "TvPlaylistPage.tsx"
  }, /*#__PURE__*/React.createElement("script", {
    type: "application/ld+json"
  }, schema)), adsConsent === 'failure' ? /*#__PURE__*/React.createElement(VideoBlocked, {
    video: currentVideo
  }) : /*#__PURE__*/React.createElement(VideoPlayer, {
    video: currentVideo,
    playlist: playlist,
    isFetching: isFetching,
    dispatch: dispatch,
    ssrLoaded: ssrLoaded
  }));
}